<app-prospect-cell [prospect]="prospect()"></app-prospect-cell>
